import { FieldValue } from "backend/datainput";
import ValueInputForm from "design/components/forms/ValueInputForm";
import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";
import useComments from "backend/hooks/comments/useComments";
import Loader from "@qpr/client-api-base/ui/components/Loader";
import useAttachments from "backend/hooks/files/useAttachments";

const KPIValueInput = (props: {
  item: ICardElementWithChildren;
  onSubmit?: (values: FieldValue[]) => void;
  onSave?: (values: FieldValue[]) => void;
  isReadOnly?: boolean;
}) => {
  const { item: selectedRow } = props;
  const { data: comments, isLoading } = useComments({
    id: selectedRow?.workflowInstance?.meaId || "",
    period: selectedRow?.workflowInstance?.period || "",
  });
  const { data: attachments, isLoading: isLoadingAttachments } = useAttachments(
    { elementId: props.item.id, period: props.item.workflowInstance?.period }
  );

  if (isLoading || isLoadingAttachments) return <Loader />;
  return (
    <ValueInputForm
      buttons={[
        {
          tag: "save",
          style: "save",
          text: t("workflowinput.form.Save").toString(),
          onClick: props.onSave,
        },
        {
          tag: "submit",
          style: "submit",
          text: t("workflowinput.form.Submit").toString(),
          onClick: props.onSubmit,
        },
      ]}
      key={selectedRow?.workflowInstance?.wfInstanceId}
      element={selectedRow!}
      onIntermediateChange={(values) => {
        console.log(values);
      }}
      fields={[
        {
          title: t("workflowinput.form.ACT").toString(),
          series: "ACT",
          element: selectedRow,
          inputType: "string",
          isDisabled: props.isReadOnly,
          unitSeries: "ACT_unitname",
          validate: (state) => {
            // allow empty ACT values for initiative
            if (
              typeof state.field.value === "undefined" ||
              state.field.value === ""
            ) {
              return {
                success: true,
                errorMessages: [],
              };
            }

            if (!state.field.value) {
              return {
                success: false,
                errorMessages: [
                  t("workflowinput.form.errors.Value can not be empty"),
                ],
              };
            }

            if (!/^-?\d*\.?\d*$/.test(state.field.value)) {
              return {
                success: false,
                errorMessages: [
                  t("workflowinput.form.errors.Value must be number"),
                ],
              };
            }

            return {
              success: true,
              errorMessages: [],
            };
          },
        },
        {
          title: t("workflowinput.form.Attachments"),
          element: selectedRow,
          inputType: "attachments",
          initialFiles: attachments,
          isDisabled: props.isReadOnly,
        },
        {
          title: t("workflowinput.form.Actions and Recommendations"),
          element: selectedRow,
          inputType: "comment",
          comments: comments,
          isDisabled: props.isReadOnly,
          initialValue: comments && comments[0] ? comments[0].description : "",
        },
      ]}
    />
  );
};

export default KPIValueInput;
